import React from "react";
import { FormattedMessage } from "react-intl";

import PageContent from "2g-page-content";
import PageMessage from "2g-page-message";
import { Icons } from "2g-icons";

function NotFound() {
  return (
    <PageContent>
      <PageMessage icon={Icons.Permissions} type="danger">
        <div>
          <FormattedMessage id="b2b.auth.unauthorized.first-row" />
        </div>
        <div>
          <FormattedMessage id="b2b.auth.unauthorized.second-row" />
        </div>
      </PageMessage>
      ;
    </PageContent>
  );
}

export default React.memo(NotFound);
